exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header, .footer {\n  text-align: center; }\n\n.title {\n  width: 100%;\n  font-size: 1.2rem;\n  color: black;\n  text-decoration: none; }\n\n.list {\n  padding: .8rem; }\n\n.listItem {\n  margin: .4rem auto; }\n\n.colorTitle {\n  text-align: right;\n  color: #aaa; }\n\n.colorCode {\n  text-align: right;\n  font-size: 1.5rem; }\n\n.colorDot {\n  width: 64px;\n  height: 64px;\n  border-radius: 100%;\n  margin-right: .8rem; }\n  .colorDot.small {\n    margin-right: -1rem; }\n\n.logo {\n  width: 100%;\n  margin: .6rem;\n  font-size: 2rem;\n  text-decoration: none;\n  color: black; }\n\n.showMore {\n  margin-top: .6rem; }\n\n.center {\n  margin: 0 auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/collection/components/embed-collection/embed-collection.component.scss
// module id = ../../../../../src/app/collection/components/embed-collection/embed-collection.component.scss
// module chunks = main